import './config';
import React from 'react';
import ReactDOM from 'react-dom';
import { global } from '@abyss/ui/tools/styled';
import { AppProvider } from '@abyss/ui/utility/AppProvider';
// import { configureAppStore } from '../state/store';
// import { attachStylesheet } from '../styles/stylesheet';
// import { theme } from '../styles/theme';
import { QueryClient, QueryClientProvider } from 'react-query';
import { styles } from './styles';
import { theme } from './theme';
import { App } from './App';
import { loadFeatures, loadPaanFeatures } from '../tools/features';

const queryClient = new QueryClient();
const AppStyles = global`${styles}`;

// export const store = configureAppStore();
// export const styles = attachStylesheet();

const render = async () => {
  await loadFeatures();
  await loadPaanFeatures();

  ReactDOM.render(
    <AppProvider theme={theme.theme}>
      <QueryClientProvider client={queryClient}>
        <AppStyles />
        <App />
      </QueryClientProvider>
    </AppProvider>,
    document.getElementById('root')
  );
};

if (module.hot) {
  module.hot.accept('./App', () => {
    render();
  });
}

render();
